/**
 * CommunityNav — Home/Discussions/Books/Events/Members/About, adapting
 * to Writing/Prompts/Critiques for writer communities.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { cx } from '@/components/site/primitives';
import { READER_NAV_TABS, WRITER_NAV_TABS } from './constants';

export default function CommunityNav({ type, activeTab, onChange }) {
  const tabs = type === 'writer' ? WRITER_NAV_TABS : READER_NAV_TABS;

  return (
    <nav className="sticky top-16 z-20 border-b border-line bg-cream/90 backdrop-blur-md" role="tablist" aria-label="Community sections">
      <div className="u-container">
        <div className="scrollbar-none -mx-1 flex snap-x items-center gap-1 overflow-x-auto px-1">
          {tabs.map(tab => {
            const isActive = activeTab === tab.key;
            return (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => onChange(tab.key)}
                className={cx(
                  'relative shrink-0 snap-start whitespace-nowrap px-3.5 py-3 text-sm font-medium transition-colors duration-200',
                  isActive ? 'text-coral' : 'text-subtle hover:text-ink'
                )}
              >
                {tab.label}
                {isActive && (
                  <motion.span
                    layoutId="community-tab-underline"
                    className="absolute -bottom-px left-2 right-2 h-[2.5px] rounded-full bg-coral"
                    transition={{ type: 'spring', stiffness: 420, damping: 34 }}
                  />
                )}
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
